<aside class="container">
  <div class="row">
    <div class="col-xl-8 col-lg-8 col-md-8 col-12">
      <div class="videoContend">
        <div class="tituloV" [ngSwitch]="idioma">
          <ng-container *ngSwitchCase="'2'">
            <h2>
              {{etiquetasIn.id}}
            </h2>
          </ng-container>
          <ng-container *ngSwitchCase="'3'">
            <h2>
              {{etiquetasZh.id}}
            </h2>
          </ng-container>
          <ng-container *ngSwitchCase="'4'">
            <h2>
              {{etiquetasFr.id}}
            </h2>
          </ng-container>
          <ng-container *ngSwitchCase="'5'">
            <h2>
              {{etiquetasDe.id}}
            </h2>
          </ng-container>
          <ng-container *ngSwitchCase="'6'">
            <h2>
              {{etiquetasRu.id}}
            </h2>
          </ng-container>
          <ng-container *ngSwitchCase="'7'">
            <h2>
              {{etiquetasBr.id}}
            </h2>
          </ng-container>
          <ng-container *ngSwitchCase="'8'">
            <h2>
              {{etiquetasKr.id}}
            </h2>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <h2>
              {{etiquetas.id}}
            </h2>
          </ng-container>
        </div>
        <!-- Video -->
        <video controls autoplay #videoPlayer>
          <source src="./assets/videos/Sistema de rastreo satelital para contenedores USat-i.mp4" type="video/mp4">
        </video>
        <!-- Descripción de los videos -->
        <div class="row " [ngSwitch]="idioma">
          <!-- *************************************************************************Ingles**************************************************************** -->
          <ng-container *ngSwitchCase="'2'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
              <div class="videoDescripcion">
                <h5>
                  {{modeloVideoIn.nombre}}
                </h5>
                <h6>{{etiquetasIn.descripcion}}</h6>
                <p>{{videoDescripcionIn.descripcion}}</p>

                <h6>{{etiquetasIn.imagen}} </h6>
                <p>
                  {{videoDescripcionIn.imagen}}
                </p>
              </div>
            </div>
          </ng-container>
          <!-- *************************************************************************Chino**************************************************************** -->
          <ng-container *ngSwitchCase="'3'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
              <div class="videoDescripcion">
                <h5>
                  {{modeloVideoZh.nombre}}
                </h5>
                <h6>{{etiquetasZh.descripcion}} </h6>
                <p>{{videoDescripcionZh.descripcion}}</p>

                <h6>{{etiquetasZh.imagen}} </h6>
                <p>
                  {{videoDescripcionZh.imagen}}
                </p>
              </div>
            </div>
          </ng-container>
          <!-- *************************************************************************Frances**************************************************************** -->
          <ng-container *ngSwitchCase="'4'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
              <div class="videoDescripcion">
                <h5>
                  {{modeloVideoFr.nombre}}
                </h5>
                <h6>{{etiquetasFr.descripcion}}</h6>
                <p>{{videoDescripcionFr.descripcion}}</p>

                <h6>{{etiquetasFr.imagen}} </h6>
                <p>
                  {{videoDescripcionFr.imagen}}
                </p>
              </div>
            </div>
          </ng-container>
          <!-- *************************************************************************Aleman**************************************************************** -->
          <ng-container *ngSwitchCase="'5'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
              <div class="videoDescripcion">
                <h5>
                  {{modeloVideoDe.nombre}}
                </h5>
                <h6>{{etiquetasDe.descripcion}}</h6>
                <p>{{videoDescripcionDe.descripcion}}</p>

                <h6>{{etiquetasDe.imagen}} </h6>
                <p>
                  {{videoDescripcionDe.imagen}}
                </p>
              </div>
            </div>
          </ng-container>
          <!-- *************************************************************************Ruso**************************************************************** -->
          <ng-container *ngSwitchCase="'6'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
              <div class="videoDescripcion">
                <h5>
                  {{modeloVideoRu.nombre}}
                </h5>
                <h6>{{etiquetasRu.descripcion}}</h6>
                <p>{{videoDescripcionRu.descripcion}}</p>

                <h6>{{etiquetasRu.imagen}} </h6>
                <p>
                  {{videoDescripcionRu.imagen}}
                </p>
              </div>
            </div>
          </ng-container>
          <!-- *******************************************************************Portugués Brasil************************************************************** -->
          <ng-container *ngSwitchCase="'7'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
              <div class="videoDescripcion">
                <h5>
                  {{modeloVideoBr.nombre}}
                </h5>
                <h6>{{etiquetasBr.descripcion}}</h6>
                <p>{{videoDescripcionBr.descripcion}}</p>

                <h6>{{etiquetasBr.imagen}} </h6>
                <p>
                  {{videoDescripcionBr.imagen}}
                </p>
              </div>
            </div>
          </ng-container>
          <!-- *******************************************************************Coreano*********************************************************************** -->
          <ng-container *ngSwitchCase="'8'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
              <div class="videoDescripcion">
                <h5>
                  {{modeloVideoKr.nombre}}
                </h5>
                <h6>{{etiquetasKr.descripcion}}</h6>
                <p>{{videoDescripcionKr.descripcion}}</p>

                <h6>{{etiquetasKr.imagen}} </h6>
                <p>
                  {{videoDescripcionKr.imagen}}
                </p>
              </div>
            </div>
          </ng-container>
          <!-- *************************************************************************Español**************************************************************** -->
          <ng-container *ngSwitchDefault>
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
              <div class="videoDescripcion">
                <h5>
                  {{modeloVideo.nombre}}
                </h5>
                <h6>{{etiquetas.descripcion}} </h6>
                <p>{{videoDescripcion.descripcion}}</p>

                <h6>{{etiquetas.imagen}} </h6>
                <p>
                  {{videoDescripcion.imagen}}
                </p>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- Boton de descarga manual -->
        <div class="descargarManual">
          <div [ngSwitch]="idioma">
            <ng-container *ngSwitchCase="'2'">
              <a class="btn" href="./assets/document/Usat-i Manual.pdf" download>{{etiquetasIn.URL}}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'3'">
              <a class="btn" href="./assets/document/Usat-i Manual.pdf" download>{{etiquetasZh.URL}}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'4'">
              <a class="btn" href="./assets/document/Usat-i Manual.pdf" download>{{etiquetasFr.URL}}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'5'">
              <a class="btn" href="./assets/document/Usat-i Manual.pdf" download>{{etiquetasDe.URL}}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'6'">
              <a class="btn" href="./assets/document/Usat-i Manual.pdf" download>{{etiquetasRu.URL}}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'7'">
              <a class="btn" href="./assets/document/Usat-i Manual.pdf" download>{{etiquetasBr.URL}}</a>
            </ng-container>
            <ng-container *ngSwitchCase="'8'">
              <a class="btn" href="./assets/document/Usat-i Manual.pdf" download>{{etiquetasKr.URL}}</a>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <a class="btn" href="./assets/document/Usat-i Manual.pdf" download>{{etiquetas.URL}}</a>
            </ng-container>
          </div>
        </div>
      </div>

    </div>

    <!-- Lista de videos -->
    <div class="col-xl-4 col-lg-4 col-md-4 col-12 listButton">
      <div class="tituloL" [ngSwitch]="idioma">
        <ng-container *ngSwitchCase="'2'">
          <h2>
            {{etiquetasIn.nombre}}
          </h2>
        </ng-container>
        <ng-container *ngSwitchCase="'3'">
          <h2>
            {{etiquetasZh.nombre}}
          </h2>
        </ng-container>
        <ng-container *ngSwitchCase="'4'">
          <h2>
            {{etiquetasFr.nombre}}
          </h2>
        </ng-container>
        <ng-container *ngSwitchCase="'5'">
          <h2>
            {{etiquetasDe.nombre}}
          </h2>
        </ng-container>
        <ng-container *ngSwitchCase="'6'">
          <h2>
            {{etiquetasRu.nombre}}
          </h2>
        </ng-container>
        <ng-container *ngSwitchCase="'7'">
          <h2>
            {{etiquetasBr.nombre}}
          </h2>
        </ng-container>
        <ng-container *ngSwitchCase="'8'">
          <h2>
            {{etiquetasKr.nombre}}
          </h2>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <h2>
            {{etiquetas.nombre}}
          </h2>
        </ng-container>
      </div>
      <div class="row">
        <div class="videoList col-xl-12 col-lg-12 col-md-12 col-12 " *ngFor='let video of data[0].default.video' id="">

          <a value="" id="{{video.id}}" (click)='getUrl(video.id)'>
            <div class="videoC d-inline">
              <img src="{{video.imagen}}" alt="">
            </div>
            <div class="nombreVideo d-inline texthoverTitle" [ngSwitch]="idioma">
              <ng-container *ngSwitchCase="'2'">
                <span class="listTitle texthoverTitle">{{video.nombreVIn}}</span><br>
                <span class="listDes">{{video.duracionIn}}</span>
              </ng-container>
              <ng-container *ngSwitchCase="'3'">
                <span class="listTitle texthoverTitle">{{video.nombreVZh}}</span><br>
                <span class="listDes">{{video.duracionZh}}</span>
              </ng-container>
              <ng-container *ngSwitchCase="'4'">
                <span class="listTitle texthoverTitle">{{video.nombreVFr}}</span><br>
                <span class="listDes">{{video.duracionFr}}</span>
              </ng-container>
              <ng-container *ngSwitchCase="'5'">
                <span class="listTitle texthoverTitle">{{video.nombreVDe}}</span><br>
                <span class="listDes">{{video.duracionDe}}</span>
              </ng-container>
              <ng-container *ngSwitchCase="'6'">
                <span class="listTitle texthoverTitle">{{video.nombreVRu}}</span><br>
                <span class="listDes">{{video.duracionRu}}</span>
              </ng-container>
              <ng-container *ngSwitchCase="'7'">
                <span class="listTitle texthoverTitle">{{video.nombreVBr}}</span><br>
                <span class="listDes">{{video.duracionBr}}</span>
              </ng-container>
              <ng-container *ngSwitchCase="'8'">
                <span class="listTitle texthoverTitle">{{video.nombreVKr}}</span><br>
                <span class="listDes">{{video.duracionKr}}</span>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <span class="listTitle texthoverTitle">{{video.nombreV}}</span><br>
                <span class="listDes">{{video.duracion}}</span>
              </ng-container>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</aside>